import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderPaper: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFolderPaper"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H17V5H21V10H22V21H2V7H3V3ZM19.5 10V6.5H17V10H19.5ZM15.5 10V4.5H4.5V7H9.06066L12.0607 10H15.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderPaper;
